import { LOCATION_CHANGE } from 'react-router-redux';

function modal(state = false, action) {
  switch (action.type) {
    case 'SHOW_STATUS_MODAL' :
      return true;
    case 'HIDE_STATUS_MODAL' :
      return false;
    case LOCATION_CHANGE :
      return false;
    default:
      return state;
  }
}

export default modal;
